import getPlanCode from "./getPlanCodes";

const onboardingSteps = [
    {
        step: 1,
        title: "What type of business are you?",
        description: "Select your business type to see the right plan and pricing.",
        progress: 12.5,
    },
    {
        step: 2,
        title: "Tell us about your business",
        description: "This info will be shown to customers when they browse print shops on SignetPrint.",
        progress: 25,
    },
    {
        step: 3,
        title: "Where are you located?",
        description: "This helps customers find you. Your address will be shown on your shop profile.",
        progress: 37.5,
    },
    {
        step: 4,
        title: "Add a shop photo",
        description: "Shops with photos get up to 3x more engagement. Show customers what your shop looks like, or skip this step and add one later.",
        progress: 50,
        optional: true,
    },
    {
        step: 5,
        title: "What supplies do you offer?",
        description: "Select the supply categories you stock - e.g. printing machines, signage supplies, sublimation materials. Customers will search and filter by these.",
        progress: 62.5,
    },
    {
        step: 6,
        title: "Set your operating hours",
        description: "Let customers know when you're open. You can update these anytime.",
        progress: 75,
    },
    {
        step: 7,
        title: "Review your details",
        description: "Make sure everything looks good before going live. You can always edit later.",
        progress: 87.5,
    },
    {
        step: 8,
        title: "Create your account",
        description: "Set up your login credentials to access your store dashboard. You'll use these to manage orders and update your shop details.",
        progress: 100,
    },
];

const plansData = {
    printShop: {
        key: "printShop",
        title: "On-Demand Print Shop Pro",
        price: "R349",
        description:
            "For everyday On-Demand Print shops. Receive files, manage orders, and grow your print shop online.",
        features: [
            "Listed on SignetPrint marketplace",
            "Unlimited file uploads",
            "Unlimited customer enquiries",
            "Full order management dashboard",
            "Priority listing in search",
            "Analytics dashboard",
            "Email & SMS notifications",
            "Dedicated support",
        ],
        planCode: getPlanCode(
            process.env.REACT_APP_PRINTSHOP_PLAN_TEST,
            process.env.REACT_APP_PRINTSHOP_PLAN_LIVE
        ),
    },
    specialist: {
        key: "specialist",
        title: "Specialist Print Pro",
        price: "R199",
        description:
            "For t-shirt, mug, bag, signage, and any other specialist printers. Enquiries land directly  in your dashboard and inbox.",
        features: [
            "Listed on SignetPrint marketplace",
            "Unlimited customer enquiries",
            "Enquiries dashboard",
            "Priority listing in search",
            "Email & SMS notifications",
            "Referral analytics",
            "Dedicated support",
        ],
        planCode: getPlanCode(
            process.env.REACT_APP_SPECIALIST_PLAN_TEST,
            process.env.REACT_APP_SPECIALIST_PLAN_LIVE
        ),
    },

    supplier: {
        key: "supplier",
        title: "Supplier Pro",
        price: "R199",
        description:
            "For suppliers of print machinery, papers, inks, toner, and other print supplies. Enquiries land straight in your email.",
        features: [
            "Listed on SignetPrint marketplace",
            "Unlimited customer enquiries",
            "Priority listing in search",
            "Email & SMS notifications",
            "Referral analytics",
            "Dedicated support",
        ],
        planCode: getPlanCode(
            process.env.REACT_APP_SUPPLIER_PLAN_TEST,
            process.env.REACT_APP_SUPPLIER_PLAN_LIVE
        ),
    },
};

const INK_COMPATIBILITY_OPTIONS = [
    {
        key: "solvent",
        title: "Solvent",
        desc: "For outdoor & industrial applications - durable and weather-resistant",
    },
    {
        key: "eco-solvent",
        title: "Eco-Solvent",
        desc: "For indoor signage & vehicle wraps - low odour, vibrant colours",
    },
    {
        key: "latex",
        title: "Latex",
        desc: "For high-volume production - fast drying, scratch-resistant",
    },
];

export {
    plansData,
    INK_COMPATIBILITY_OPTIONS,
    onboardingSteps,
}
